import { usePopup } from 'hooks/usePopup'
import { useEffect, useRef, useState } from 'react'
import { IRouteOverResponse, routeService } from 'services/routeService'

export interface IRouteOverResponseExt extends IRouteOverResponse {
  quantityToDecrease: string
}

// Kept while the old table components remain in the tree during rollout.
export interface IOption {
  icon: any
  action: (data: IRouteOverResponseExt) => void
  title: string
}

export const useRoutesOver = () => {
  const { addPopup } = usePopup()
  const controller = useRef<AbortController | null>(null)
  const timeout = useRef<any>(null)
  const [routes, setRoutes] = useState<IRouteOverResponseExt[]>([])
  const [openModal, setOpenModal] = useState<{
    open: boolean
    data: IRouteOverResponseExt | null
  }>({ open: false, data: null })
  const [loading, setLoading] = useState(false)

  const getRoutesOver = async (scheduleNext = false) => {
    clearTimeout(timeout.current)
    controller.current?.abort()
    controller.current = new AbortController()
    try {
      setLoading(true)
      const { data } = await routeService.getOverRoutes({
        controller: controller.current,
      })
      setRoutes(
        data.map(route => ({
          ...route,
          quantityToDecrease: `${route.excess_boxes} caixa${route.excess_boxes === 1 ? '' : 's'}`,
        })),
      )
    } catch (err: any) {
      if (controller.current?.signal?.aborted) return
      addPopup({
        title: 'Erro ao buscar rotas acima da capacidade',
        description: err?.message ?? err?.msg ?? 'Erro desconhecido',
        type: 'error',
        autoClose: false,
      })
    } finally {
      setLoading(false)
      if (scheduleNext && !controller.current?.signal?.aborted) {
        timeout.current = setTimeout(() => getRoutesOver(true), 5000)
      }
    }
  }

  useEffect(() => {
    getRoutesOver(true)
    return () => {
      controller.current?.abort()
      clearTimeout(timeout.current)
    }
  }, [])

  return {
    loading,
    routes,
    openModal,
    refresh: () => getRoutesOver(false),
    onClickRoute: (data: IRouteOverResponseExt) => setOpenModal({ open: true, data }),
    onCloseModal: () => setOpenModal({ open: false, data: null }),
  }
}
